// Existing function to format date as 'DD MMM YYYY HH:mm:ss'
export function formatDate(dateString) {
  const date = new Date(dateString);
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  return date
    .toLocaleString("en-GB", options)
    .replace(",", "")
    .replace(/:/g, ":");
}

// New function to format date as 'YYYY-MM-DD'
export function formatDateToYYYYMMDD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Add 1 to month since it's zero-indexed
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export const formatDateMonth = (dateString) => {
  if (!dateString) return "";

  const [datePart] = dateString?.split(" "); // remove time
  const [day, month, year] = datePart.split("-");

  const date = new Date(`${year}-${month}-${day}`);

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};